var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"selection-bar"}},[_c('div',{staticClass:"selection-action-bar"},[_c('div',{staticClass:"selection-bar-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }